import { QueryFunctionContext } from '@tanstack/react-query';
import { TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_URL } from '../../constants';
import axios from 'axios';
import { WithLastUpdated } from './index';

export interface TeamCustomizableKnowledgeBase extends WithLastUpdated {
  id?: number;
  title: string;
  description: string;
  default_knowledge_base?: number;
  module?: number;
  unique_code: string;
}

export const TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_QUERY_KEY = 'team-customizable-knowledge-base';

export const teamCustomizableKnowledgeBaseApi = {
  getList: ({ queryKey }: QueryFunctionContext) =>
    axios
      .get<
        TeamCustomizableKnowledgeBase[]
      >(`${TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_URL}?module_id=${queryKey[1]}`)
      .then((res) => res.data),
  delete: (kbId: number) => axios.delete(`${TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_URL}${kbId}`),
  post: (data: TeamCustomizableKnowledgeBase) =>
    axios.post(TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_URL, data).then((res) => res.data),
  put: (data: TeamCustomizableKnowledgeBase) =>
    axios.put(`${TEAM_CUSTOMIZABLE_KNOWLEDGE_BASE_URL}${data.id}`, data).then((res) => res.data),
};
